module.exports = __webpack_public_path__ + "img/7.2.TN.761a23c0.png";